import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Transaction = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Transaction' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,7 L20,7 M16,2 L21,7 L16,12 M22,17 L4,17 M8,12 L3,17 L8,22' />
  </StyledIcon>
);
